import { render, staticRenderFns } from "./Clube.vue?vue&type=template&id=39700b87"
import script from "./Clube.vue?vue&type=script&lang=ts"
export * from "./Clube.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports